import {JSX} from "/@lib@/commons/xml/dom.js";
import {EItemTypeFamily} from "/@lib@/wsp/wspMetaUi.js";
import {FocusItem, SrcAction} from "/@back@/wsp/actions/srcActions.js";
import {IShortDescCtx, ITEM} from "/@lib@/wsp/item.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";
import {ERROR} from "/@lib@/core/errorReport.js";
import {TASK} from "/@lib@/wsp/lcTask.js";
import {REG} from "/@lib@/commons/registry.js";

/**
 * Action qui affiche et focus une tâche
 */
export class FocusTask extends FocusItem {
	static SINGLETON = new FocusTask();

	constructor() {
		super('focusTask');
		this._label = "Afficher cette tâche";
		this._icon = "/@skin@/wsp/actions/showItem.svg";
		this._group = "open";
		this.exactOne = true;
		this.isNotRemoved = false;
		this.families = ['task' as EItemTypeFamily.task];
	}
}

REG.reg.registerSvc('tasks/focusTaskAction', 1, FocusTask.SINGLETON);

/**
 * Suppression de taches
 */
export class DeleteTask extends SrcAction<IShortDescCtx> {

	static SINGLETON = new DeleteTask();

	constructor() {
		super('delSrc');
		this._label = "Supprimer";
		this._group = "edit";
		this.atLeastOne = true;
		this._enableSrcPerms = ["write.task.delete"];
		this.families = ['task' as EItemTypeFamily.task];
	}

	async execute(ctx: IShortDescCtx, ev?: Event) {
		let ok: boolean;
		if (ctx.shortDescs.length === 1) {
			const uri = ctx.shortDescs[0].srcUri;
			const name = ITEM.getSrcMainName(ctx.reg, ctx.shortDescs[0], ctx.reg.env.wsp.wspMetaUi);
			ok = await POPUP.confirm(`Supprimer DÉFINITIVEMENT cette tâche "${name}" ?`, ctx.emitter);
		} else {
			const length = ctx.shortDescs.length;
			ok = await POPUP.confirm(`Supprimer DÉFINITIVEMENT ces ${length} tâches ?`, ctx.emitter);
		}
		if (ok) {
			try {
				await TASK.deleteTask(ctx.reg.env.wsp, ctx.emitter, ctx.shortDescs.map((entry) => entry.srcId))
			} catch (e) {
				await ERROR.report("Une erreur est survenue lors de la suppression.", e, ctx);
			}
		}
	}
}

REG.reg.registerSvc('tasks/deleteTaskAction', 1, DeleteTask.SINGLETON);